<div class="header-navigation-back">
  <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
  <span class="title">Resume</span>
</div>
<div  class="content full-height">
  @if (uploaded && !loading) {
    <div class="padding-left-md padding-right-md">
      <p>Your Resume was uploaded to our system on {{ createdDate }}.</p>
      <p>
        If you need further assistance, please get in touch with one of our support group at
        <a href="mailto:${this.supportEmail}">{{ this.supportEmail }}.</a>
      </p>
    </div>
  }
  @if (!uploaded && !loading) {
    <div
      class="padding-left-md padding-right-md full-height"
      >
      @if (!attempted) {
        <p>Upload your latest resume here</p>
      }
      <p class="help-text">
        email us at <a href="mailto:{{ this.supportEmail }}" class="help-text">{{ this.supportEmail }}.</a> if you have
        questions
      </p>
    </div>
  }
</div>
@if (!uploaded && !loading) {
  <div  class="botttom-position">
    <div >
      @if (errorMessage) {
        <mat-error class="error padding-bottom-sm">
          {{ errorMessage }}
        </mat-error>
      }
      @if (successMessage) {
        <p>
          {{ successMessage }}
        </p>
      }
    </div>
    @if (attempted) {
      <button
        mat-raised-button
        class="select-file-button"
        type="button"
        [disabled]="!attempted"
        (click)="onNavigateToProfile()"
        >
        Back
      </button>
    }
    @if (!attempted) {
      <button
        mat-raised-button
        class="select-file-button"
        type="button"
        [disabled]="successMessage"
        (click)="fileToUpload.click()"
        >
        Upload
      </button>
    }
    <input
      mat-input
      #fileToUpload
      type="file"
      accept="application/pdf"
      [disabled]="loading || successMessage"
      (change)="onFileChange(fileToUpload)"
      class="hidden-input-field"
      />
  </div>
}
